import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ProjectSample from "../project_samples/ProjectSamples";
import ProjectSampleMobile from "../project_samples/ProjectSamplesMobile";

import lazuli from '../image/flagship-collection/lazuli-flagship.webp'


import MailchimpForm from "../MailChimpForm";

import lazuliskirt1 from '../image/flirty-lazuli/lazuliskirt1.webp'
import lazulitop1 from '../image/flirty-lazuli/lazulitop1.webp'
import lazulitwopiece from '../image/flirty-lazuli/twopiece1.webp'

import allstar1 from '../image/purses/allstar1.webp'
import allstar2 from '../image/purses/allstar2.webp'
import allstar3 from '../image/purses/allstar3.webp'

import selene1 from '../image/selene-collection/selenebottom.webp'
import selene2 from '../image/selene-collection/seleneshorts.webp'
import selene3 from '../image/selene-collection/selenedress.webp'

import universe from '../image/originals/quantum/universe.webp'
import marilyn from '../image/originals/hollywoodicons/marilyn.jpg'
import jordan from '../image/originals/nba/michael.webp'


const Projects = () => {

  const h2Elements = [
    "FLIRTY LAZULI COLLECTION",
    "SELENE PRINCESS COLLECTION",
    "PAINTINGS",
    "PURSES",
  ];
  
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  


  const dresses = [
    {
      title: "Flirty Lazuli Two Piece Dress",
      imageUrl: lazulitwopiece,
      projectUrl:
        "/FlirtyLazuliTwoPiece",
    },
    {
      title: "Flirty Lazuli Skirt",
      imageUrl: lazuliskirt1,
      projectUrl:
        "/FlirtyLazuliSkirt",
    },
    {
      title: "Flirty Lazuli Tops",
      imageUrl: lazulitop1,
      projectUrl:
        "/FlirtyLazuliTop",
    },
  ];

  const selene = [
    {
      title: "Selene Princess Swimwear High Waisted Reversible Bikini Bottom",
      imageUrl: selene1,
      projectUrl: "/Shop",
    },
    {
      title: "Selene Princess High Waisted Workout Shorts",
      imageUrl: selene2,
      projectUrl: "/SeleneShorts",
    },
    {
      title: "Selene Princess Dress",
      imageUrl: selene3,
      projectUrl: "/SeleneDress",
    },
    // {
    //   title: "Selene Princess revesible Swimwear and Workout Top",
    //   imageUrl: selene4,
    //   projectUrl: "/SeleneBikiniTop",
    // },
    // {
    //   title: "Selene Princess Workout Pants",
    //   imageUrl: selene5,
    //   projectUrl: "/SelenePants",
    // },
  ];

  const purses = [
    {
      title: "",
      imageUrl: allstar1,
      projectUrl: "/AllStarPurse",
    },
    {
      title: "All Star Purse",
      imageUrl: allstar2,
      projectUrl: "/AllStarPurse",
    },
    {
      title: "",
      imageUrl: allstar3,
      projectUrl: "/AllStarPurse",
    },
  ];

  const paintings = [
    {
      title: "Astronaut Series",
      imageUrl: universe,
      projectUrl: "/QuantumCollection",
    },
    {
      title: "Hollywood Icons",
      imageUrl: marilyn,
      projectUrl: "/HollywoodCollection",
    },
    {
      title: "NBA All-Stars",
      imageUrl: jordan,
      projectUrl: "/NBAAllStars",
    },
  ];

  // useEffect(() => {
  //     const section = document.querySelector(".flagship-section");

  //     const observer = new IntersectionObserver((entries) => {
  //       entries.forEach((entry) => {
  //         if (entry.isIntersecting) {
  //           section.classList.add("fade-out");
  //         } else {
  //           section.classList.remove("fade-out");
  //         }
  //       });
  //     });

  //     observer.observe(section);

  //     return () => observer.disconnect();
    
  // }, []);
  useEffect(() => {
    fetch(
      "https://stripe-server-reena-36b70709cadc.herokuapp.com/create-checkout-session"
    );
  }, []);
  
  const collections = [
    {
      title: h2Elements[0],
      href: "/FlirtyLazuli",
      items: dresses,
      eyebrow: "Featured collection",
    },
    {
      title: h2Elements[1],
      href: "/SeleneCollection",
      items: selene,
      eyebrow: "Wearable art",
    },
    {
      title: h2Elements[2],
      href: "/original-paintings-1",
      items: paintings,
      eyebrow: "Original work",
    },
    {
      title: h2Elements[3],
      href: "/Purses",
      items: purses,
      eyebrow: "Accessories",
    },
  ];

  const navLinks = [
    { label: "Home", href: "/" },
    { label: "Wearable Art & Thangz", href: "/merch" },
    { label: "Original Paintings", href: "/original-paintings-1" },
    { label: "Limited Edition Prints", href: "/Prints" },
  ];


  
  return (
    <main className="Content home-page">
      <section className="home-hero fade-out" aria-labelledby="home-hero-title">
        <div className="home-hero-copy">
          <p className="home-kicker">Wearable art, paintings, and limited edition prints</p>
          <h1 id="home-hero-title">Colorful pieces made to be lived in.</h1>
          <p>
            Explore Reena Tolentino's art-forward collections, from expressive
            fashion capsules to original paintings and collectible prints.
          </p>
          <div className="home-hero-actions">
            <Link className="home-primary-link" to="/FlirtyLazuli">
              Shop Flirty Lazuli
            </Link>
            <Link className="home-secondary-link" to="/original-paintings-1">
              View paintings
            </Link>
          </div>
        </div>
        <Link className="home-hero-frame" to="/FlirtyLazuli" aria-label="Shop the Flirty Lazuli collection">
          <img
            src={lazuli}
            className="home-hero-image"
            alt="Flirty Lazuli collection campaign"
            draggable="false"
          />
        </Link>
      </section>

      <section className="home-newsletter" aria-label="Newsletter signup">
        <div className="home-newsletter-card">
          <div className="home-newsletter-copy">
            <p className="home-kicker">Studio notes</p>
            <h2>Subscribe to the RT Newsletter</h2>
            <p>Get collection launches, new painting drops, and limited print updates.</p>
          </div>
          <MailchimpForm />
        </div>
      </section>

      <section className="home-featured-collections" aria-label="Featured collections">
        {collections.map((collection) => (
          <article className="home-collection-section" key={collection.title}>
            <div className="home-collection-heading">
              <p className="home-kicker">{collection.eyebrow}</p>
              <Link to={collection.href} className="home-section-title">
                <h2>{collection.title}</h2>
              </Link>
            </div>
            {isMobile ? (
              <ProjectSampleMobile items={collection.items} />
            ) : (
              <ProjectSample items={collection.items} />
            )}
          </article>
        ))}
      </section>

      <footer className="home-footer">
        <div className="home-footer-brand">
          <h2>You Are Art</h2>
          <p>Wearable art, original paintings, and limited edition prints.</p>
        </div>
        <nav className="home-footer-nav" aria-label="Footer navigation">
          {navLinks.map((link) => (
            <Link key={link.href} to={link.href}>
              {link.label}
            </Link>
          ))}
        </nav>
        <p className="home-footer-copyright">
          &copy; {new Date().getFullYear()} Reena Tolentino. All rights reserved.
        </p>
      </footer>
    </main>
  );
};

export default Projects;
